module.exports = __webpack_public_path__ + "img/load-file.20ea6de0.jpg";